import angular from "angular";
import { UserProfileDetailComponent } from "./user-profile-detail.component";
import { UserProfileOnboardingDetailsComponent } from "./user-profile-onboarding-details.component";
import { UserProfileRoutingModule } from "./user-profile-routing.module";
import { SharedModule } from "../../shared/shared.module";

/** A module exposing components used to display account user profile information. */
export const UserProfileModule = angular
    .module("apex.mainApp.account.userProfile", [
        SharedModule,
        UserProfileRoutingModule
    ])
    .component("apexUserProfileDetail", UserProfileDetailComponent)
    .component("apexUserProfileOnboardingDetails", UserProfileOnboardingDetailsComponent)
    .name;
